import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import FunctionalDialog from '../FunctionalDialog';

export enum CopyrightViolationType {
  RELEASE,
  PDF_LICENSE,
}

interface PropsType {
  variant: CopyrightViolationType;
  isOpen: boolean;
  onClose: () => void;
}

const CopyrightViolationModal = ({ variant, isOpen, onClose }: PropsType) => {
  const { t } = useTranslation();

  const title = useMemo(() => {
    if (variant === CopyrightViolationType.RELEASE) {
      return t('general:copyrightViolationModal:release:title');
    }
    return t('general:copyrightViolationModal:pdfLicense:title');
  }, [t, variant]);

  const description = useMemo(() => {
    if (variant === CopyrightViolationType.RELEASE) {
      return t('general:copyrightViolationModal:release:description');
    }
    return t('general:copyrightViolationModal:pdfLicense:description');
  }, [t, variant]);

  return (
    <FunctionalDialog
      title={title}
      description={description}
      state={{
        isOpen,
        error: null,
        isLoading: false,
      }}
      action={{
        onSubmit: onClose,
        onClose,
      }}
      submitText={t('general:copyrightViolationModal:submit')}
    />
  );
};

export default CopyrightViolationModal;
